import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  searchFacetChange,
  submitSearchFacet,
  updateFilterOption,
} from '../../Actions/FacetedSearch.action';
import SideMenu from '../SideMenu';
import FacetedSearch from '../FacetedSearch';
import Icon from '../IconBase/Icon';
import { translate } from '../../Services/translation';
import useIsMobile from '../../Hooks/useIsMobile';

const FilterTogglerButton = () => {
  const facetedSearchState = useSelector((state) => state.facetedSearch);
  const activeFiltersCount = facetedSearchState.facetFilters
    .map((f) => f.selectedOptions.length)
    .reduce((a, b) => a + b, 0);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [activeFilterGroup, setActiveFilterGroup] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const isMobile = useIsMobile();
  const filterGroups = facetedSearchState.facetFilters;
  const dispatch = useDispatch();
  const clearSelectedFilters = () => {
    // Set all selectedOptions to an empty array
    setIsLoading(true);
    filterGroups.forEach((f) => (f.selectedOptions = []));
    dispatch(submitSearchFacet(filterGroups));
    setFilterMenuOpen(false);
  };

  const headerRef = (
    <div className="filter-menu__back" onClick={() => setFilterMenuOpen(false)}>
      {translate('category.filter')}
    </div>
  );

  const openSpecificFilterGroup = (filtergrpId) => {
    setActiveFilterGroup(filtergrpId);
    setFilterMenuOpen(!filterMenuOpen);
  };

  const footer = (
    <div className="filter-menu__footer-buttons">
      <button className="btn btn--outline" onClick={clearSelectedFilters}>
        {translate('mobile-filter-menu.clear-filters')}
      </button>
      <button
        className="btn btn--black filter-menu__show-products-btn"
        onClick={() => setFilterMenuOpen(false)}
      >
        {
          <span>
            {translate('global.show')}{' '}
            {facetedSearchState.totalCount > 0 &&
              '(' + facetedSearchState.totalCount + ')'}
          </span>
        }
      </button>
    </div>
  );

  return (
    <>
      {isMobile ? (
        <div
          className="btn btn--outline"
          onClick={() => setFilterMenuOpen(!filterMenuOpen)}
        >
          {translate('category.filter')}
          {activeFiltersCount > 0 && (
            <span className="filter-trigger__count">{activeFiltersCount}</span>
          )}
        </div>
      ) : (
        <>
          {filterGroups.map((filterGroup) => (
            <div
              key={`filter-trigger-` + filterGroup.label}
              className="btn btn--outline"
              onClick={() => openSpecificFilterGroup(filterGroup.id)}
            >
              {filterGroup.label}{' '}
              {filterGroup.selectedOptions.length > 0 ? (
                <span className="filter-trigger__count">
                  {filterGroup.selectedOptions.length}
                </span>
              ) : null}
            </div>
          ))}
        </>
      )}
      <SideMenu
        id="filter-menu"
        className="side-menu--filters"
        headerRef={headerRef}
        footer={footer}
        open={filterMenuOpen}
        onClosed={() => setFilterMenuOpen(false)}
      >
        <FacetedSearch openedFacet={activeFilterGroup} />
      </SideMenu>
    </>
  );
};

export default FilterTogglerButton;
